{
  "Poll_Viewer_VoteCount_Modal_Voters_Private_Voter": "Private User",
  "Poll_Viewer_ShowAllOptions_CTA": "اطلع على كل الخيارات",
  "Spoiler_Reveal_Tooltip": "انقر للعرض",
  "VerticalEmbed_Event_Error_Subtitle": "This event has been deleted, replace it with another event.",
  "Viewer_Toolbar_Twitter_Tooltip": "تغريد هذا",
  "CollapsibleListPlugin_CollapseButton_AriaLabel": "تم طي العنصر",
  "Spoiler_Reveal_Video_CTA": "كشف الفيديو",
  "VerticalEmbed_Pricing_Plan": "Plan only",
  "Image_Expand_Button_AriaLabel": "توسيع الصورة",
  "VerticalEmbed_From_Price": "From",
  "Poll_Viewer_ShowAllResults_CTA": "مشاهدة النتائج كلها",
  "Spoiler_Reveal_Image_Placeholder": "تحتوي هذه الصورة على سبويلر",
  "VerticalEmbed_Ribbon": "Sale",
  "Audio_Plugin_Elapsed_Time_Slider_AriaLabel": "البحث عن شريط التمرير",
  "VerticalEmbed_Error_Subtitle": "This item has been deleted, replace it with another item.",
  "Poll_Viewer_Multiselect_Footer": "يمكنك التصويت لأكثر من إجابة.",
  "Audio_Plugin_More_Actions_Button_AriaLabel": "إظهار المزيد من عناصر التحكم في الصوت",
  "VerticalEmbed_Booking_Fetch_Error_Title": "Failed to load service",
  "Fullscreen_Close_Button_AriaLabel": "إغلاق",
  "VerticalEmbed_Event_Fetch_Error_Title": "Failed to load event",
  "UploadFile_Viewer_Loader": "جارٍ تحميل {{fileType}}",
  "Polls_Plugin_User_Avatar_Alt": "User avatar",
  "Preview_ReadMore_Label": "اقرأ المزيد",
  "Spoiler_Insert_Tooltip": "إفصاح معلومات",
  "VerticalEmbed_Product_Fetch_Error_Title": "Failed to load product",
  "Fullscreen_Shrink_Button_AriaLabel": "Shrink",
  "Audio_Plugin_Volume_Control_Slider_AriaLabel": "مستوى الصوت",
  "Spoiler_Reveal_Gallery_Placeholder": "يحتوي هذا المعرض على سبويلر",
  "Fullscreen_Expand_Button_AriaLabel": "Expand",
  "VerticalEmbed_Bookings_Button": "حجز الآن",
  "Audio_Plugin_Volume_Control_Unmute_AriaLabel": "إلغاء الكتم",
  "Spoiler_Reveal_Gallery_CTA": "كشف المعرض",
  "Poll_Viewer_ShowLess_CTA": "إظهار أقل",
  "VerticalEmbed_Disabled_Button_Tooltip": "Product page will be available once you publish your site.",
  "Audio_Plugin_Volume_Control_Mute_AriaLabel": "كتم الصوت",
  "Poll_Viewer_VoteCount_Modal_Voters_Anonymous": "+{{anonNumber}} غير معروفين",
  "Poll_Viewer_VoteCount_Modal_Voters_CTA_Follow": "تابع",
  "VerticalEmbed_Products_Button": "شراء الآن",
  "Poll_Viewer_Toast_Error_ServerDown": "لا يمكن الاتصال بالخادم. أعد المحاولة لاحقًا.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header": "{{count}} أشخاص صوتوا لهذه الإجابة",
  "Poll_Viewer_VoteCount": "{{number}} أصوات",
  "VerticalEmbed_Events_Button": "تسجيل الآن",
  "Spoiler_Reveal_Image_CTA": "كشف الصورة",
  "Poll_Viewer_Toast_Error_Connection": "لا يوجد اتصال بالإنترنت. تحقق من الاتصال.",
  "Poll_Viewer_Visibility_Owner_Footer": "يمكنك رؤية النتائج فقط.",
  "VerticalEmbed_Booking_Error_Title": "Service deleted",
  "VerticalEmbed_Product_Error_Title": "Product deleted",
  "VerticalEmbed_Fetch_Error_Subtitle": "Unable to load item information.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header_plural": "{{count}} أشخاص صوتوا لهذه الإجابة",
  "VerticalEmbed_Event_Error_Title": "Event deleted",
  "CollapsibleListPlugin_ExpandButton_AriaLabel": "تم توسيع العنصر.",
  "Audio_Plugin_Cover_Alt": "Audio cover",
  "Spoiler_Reveal_Video_Placeholder": "يحتوي هذا الفيديو على سبويلر",
  "VerticalEmbed_Product_Fetch_Error_Subtitle": "Unable to load product information.",
  "VerticalEmbed_Fetch_Error_Title": "Failed to load item",
  "Poll_Viewer_Option_AriaLabel_Unchecked": "unchecked",
  "VerticalEmbed_Product_Error_Subtitle": "This product has been deleted, replace it with another product.",
  "VerticalEmbed_Booking_Error_Subtitle": "This service has been deleted, replace it with another service.",
  "Preview_SeeFullPost_Label": "عرض المنشور كاملاً",
  "UploadFile_Viewer_Download": "تنزيل {{fileType}}",
  "VerticalEmbed_Units_Hour": "{{hours}} س",
  "VerticalEmbed_Units_Minute": "{{minutes}} د",
  "VerticalEmbed_Event_Fetch_Error_Subtitle": "Unable to load event information.",
  "VerticalEmbed_Error_Button": "Replace",
  "VerticalEmbed_Error_Title": "Item deleted",
  "VerticalEmbed_Booking_Fetch_Error_Subtitle": "Unable to load service information.",
  "Poll_Viewer_Option_AriaLabel_Checked": "checked"
}
